import Image from '@public/images/emission-calcs-csv.png'

import TextWithImageGoingOffScreen from '@/components/TextWithImageGoingOffScreen/TextWithImageGoingOffScreen'

export default function EmissionsCsv() {
    return (
        <TextWithImageGoingOffScreen
            title={`Get immediate results via spreadsheet upload`}
            paragraph={`Eliminate the hassle of manual CO₂ emission calculations with our Spreadsheet Upload Tool. Simply upload your customers’ data, and we’ll return granular emission calculations in bulk.`}
            img={Image}
        />
    )
}
